import type { CrewJobCommitStatus, CrewJobStatus } from '../types/crewJobs';

/** Website signups start as `committed` and do not fill a roster spot. */
export function countsTowardCrewRoster(status: CrewJobCommitStatus | string): boolean {
  return status === 'confirmed';
}

export function applyRosterPublicStatus(
  current: CrewJobStatus | string,
  confirmedCount: number,
  crewNeeded: number,
): CrewJobStatus | string {
  if (current !== 'released' && current !== 'filled') return current;
  return crewNeeded > 0 && confirmedCount >= crewNeeded ? 'filled' : 'released';
}

export const CREW_COMMIT_THANK_YOU_MESSAGE =
  'Thank you for committing. Someone from our team will call or email you to confirm pay, travel arrangements, and details — and to make sure this raise is a good fit — before you are finalized on the roster.';
